<template>
  <div v-loading="loading">
    <div v-if="questionnaire.length > 0 && !$store.state.auth" class="questionnaire">
      <img v-if="wWidth > 976 && $i18n.locale=='EN'"
          src="../assets/web/Questionnaire_EN.png" />
      <img v-if="wWidth > 976 && $i18n.locale=='PT'"
          src="../assets/web/Questionnaire_PT.png" />
      <img v-if="wWidth > 976 && ($i18n.locale=='ZH_TW' || $i18n.locale=='ZH_CN')"
          src="../assets/web/Questionnaire.png" />
      <img v-if="wWidth <= 976 && $i18n.locale=='EN'"
          src="../assets/phone/Questionnaire@2x_EN.png" />
      <img v-if="wWidth <= 976 && $i18n.locale=='PT'"
          src="../assets/phone/Questionnaire@2x_PT.png" />
      <img v-if="wWidth <= 976 && ($i18n.locale=='ZH_TW' || $i18n.locale=='ZH_CN')"
          src="../assets/phone/Questionnaire@2x.png" />
      <div class="q_table">
        <el-table :data="questionnaire"
                  :show-header="false"
                  @row-click="handleCurrentChange"
                  class="pointer">
          <el-table-column prop="name">
            <span slot-scope="scope" class="flex-align-row">
            <img src="../assets/web/q_highlight.gif" alt="" width="50px">
            {{scope.row.name}}</span>
          </el-table-column>
          <!-- <el-table-column width="50">
            <template>
              <i class="el-icon-s-opportunity blink"></i>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import CourseAPI from "../api/CourseAPI";
export default {
  data () {
    return {
      loading: false,
      questionnaire: []
    };
  },
  computed: {
    wWidth () {
      return this.$store.state.wWidth;
    }
  },
  methods: {
    handleCurrentChange (row) {
      console.log(row);
      if (this.$store.state.isPreview) return false;
      if (this.course.progress <= 0.8) {
        this.$alert(this.$t("message.question_tips"), this.$t("message.tips"), {
          confirmButtonText: this.$t("message.confirm"),
          callback: action => {
            console.log(action);
          }
        });
      } else {
        const code = Base64.encode(`id=${row.id}&type=user`);
        this.$router.push({
          path: "/question",
          query: {
            code: code
          }
        });
      }
    },
    get () {
      this.loading = true;
      const id = sessionStorage.getItem("courseId");
      const locale = this.$i18n.locale;
      CourseAPI.getOne(id, locale)
        .then(res => {
          this.loading = false;
          this.course = res;
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    }
  },
  created () {
    this.get();
    const id = sessionStorage.getItem("courseId") || null;
    const locale = this.$i18n.locale;
    if(id){
      CourseAPI.listQuestionnaireByCourse(id, locale)
        .then(res => {
          this.loading = false;
          this.questionnaire = res;
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.result_tips {
  font-size: 16px;
  font-weight: 500;
  color: #68d0bc;
  margin: 12px 0;
}
.questionnaire > img {
  width: 100%;
  height: auto;
}
/deep/.el-icon-s-opportunity{
  color: #16b695;
  font-size: 24px;
}
/deep/.cell{
  font-weight: bold;
}
/deep/.cell .blink {
  animation: blink 1s linear infinite;
  -webkit-animation: blink 1s linear infinite;
  -moz-animation: blink 1s linear infinite;
  -ms-animation: blink 1s linear infinite;
  -o-animation: blink 1s linear infinite;
}
.flex-align-row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
@keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
</style>